import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import Image from 'next/image';
import styled from 'styled-components';

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: theme.spacing[10],
}));

export const GoogleLoginWrapper = styled.div(() => ({ width: '100%' }));

export const CTATextContainer = styled.div({ position: 'relative' });

export const GoogleCTAText = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  display: 'inline',
  color: theme.colors.mediumEmphasisBlack,
  width: 'fit-content',
}));

export const Checkmark = styled(Image)(({ theme }) => ({
  marginRight: theme.spacing[8],
  display: 'inline-block',
  position: 'relative',
  // to match with text's line height
  top: 2,
}));
